import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";

import { UIComponent } from "./UIComponent";
import { AppErrorFormik } from "../AppErrorFormik";

export const AppImage = ({ name, label, imageStyle, preloadedInfoFromBackend, ...otherProps }) => {
  const { handleBlur, setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <label>{label}</label>
      <UIComponent
        name={name}
        id={name}
        accept="image/png, image/jpeg, image/jpg"
        onBlur={handleBlur}
        onChange={(e) => setFieldValue(name, e.target.files[0])}
        imagePreview={values[name]}
        imageURLPreview={preloadedInfoFromBackend}
        imageStyle={imageStyle}
        {...otherProps}
      />
      <AppErrorFormik error={errors[name]} visible={touched[name] && true} />
    </>
  );
};

AppImage.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  imageStyle: PropTypes.object,
  preloadedInfoFromBackend: PropTypes.object,
};
